module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Gb-Hc-Ic-Jb.c478e3cc.png";